module.exports = __webpack_public_path__ + "img/head.00af179e.png";